import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import MeshCoreInfo from "@/pages/MeshCoreInfo";
import Devices from "@/pages/Devices";
import DeviceDetail from "@/pages/DeviceDetail";
import Settings from "@/pages/Settings";
import MQTT from "@/pages/MQTT";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Connect from "@/pages/Connect";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPostEditor from "@/pages/AdminPostEditor";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/meshcore" element={<MeshCoreInfo />} />
            <Route path="/devices" element={<Devices />} />
            <Route path="/devices/:slug" element={<DeviceDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/mqtt" element={<MQTT />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/new"
              element={
                <ProtectedRoute>
                  <AdminPostEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/edit/:id"
              element={
                <ProtectedRoute>
                  <AdminPostEditor />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
